export enum ImageUploadEnum {
    view, 
    Cropper
  }